import { boolean, type InferOutput, number, object, optional } from 'valibot'

import {
  createSorterSchema,
  PACKAGE_CATEGORIES_SORT_KEYS
} from '@/features/shared/models'

export const PackageCategoriesSearchSchema = object({
  page: optional(number()),
  take: optional(number()),
  ...createSorterSchema(PACKAGE_CATEGORIES_SORT_KEYS),
  dcId: optional(number()), // DC ID
  enable: optional(boolean()) // 有効/無効
})

export type PackageCategoriesSearch = InferOutput<
  typeof PackageCategoriesSearchSchema
>
